import actionTypes from '../constants/action-types';

const saveMainLocale = (locale, resolve, reject) => ({
  type: actionTypes.SAVE_MAIN_LOCALE,
  payload: { locale, resolve, reject },
});

export default saveMainLocale;
